module.exports = __webpack_public_path__ + "media/images/undraw/matching/resume_folder-b99815ce2645a928872b5ebffeaa68a5.png";